var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"cleaveanchor",class:{
        dateInput: _vm.options.date,
        timeInput: _vm.options.time
    },attrs:{"placeholder":_vm.options.placeholder,"type":"text"},domProps:{"value":(_vm.inputValue)},on:{"input":function($event){if($event.target.composing)return;_vm.inputValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }